var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgI = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 20",
  viewBox: "0 0 186.251 142.794"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "I_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h186.251v142.794H0z",
  "data-name": "Rectangle 24"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19",
  style: {
    clipPath: "url(#I_svg__a)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M48.389 137.863 4.931 94.4a16.835 16.835 0 0 1 23.808-23.8L72.2 114.055a16.835 16.835 0 1 1-23.808 23.808",
  "data-name": "Path 10"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M181.321 28.739 72.235 137.825a16.834 16.834 0 1 1-23.808-23.807L157.513 4.931a16.835 16.835 0 0 1 23.808 23.808",
  "data-name": "Path 11"
}))));
export default SvgI;